import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import store from "./store";
import history from "./history";
import Layouts from "./layouts";
import { THEME_CONFIG } from "./configs/AppConfig";
import "./lang";
import mockServer from "./mock";
import { UploadProvider } from "contexts/UploadContext";
import FloatingUploadWidget from "components/Modal/FloatingUploadWidget";
import GlobalLoader from "components/shared-components/Loader/GlobalLoader";
import MaintenanceScreen from "components/shared-components/MaintenanceScreen";

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

const environment = process.env.NODE_ENV;

if (environment !== "production") {
  mockServer({ environment });
}

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <UploadProvider>
          <BrowserRouter history={history}>
            <ThemeSwitcherProvider
              themeMap={themes}
              defaultTheme={THEME_CONFIG.currentTheme}
              insertionPoint="styles-insertion-point"
            >
              {" "}
              <GlobalLoader />
              <Layouts />
              {/* Full-screen maintenance overlay, driven by the API 503 marker */}
              <MaintenanceScreen />
              {/* FloatingUploadWidget will handle its own visibility based on route */}
              <FloatingUploadWidget />
            </ThemeSwitcherProvider>
          </BrowserRouter>
        </UploadProvider>
      </Provider>
    </div>
  );
}

export default App;
